// extracted by mini-css-extract-plugin
module.exports = {"field":"NumberInput_field__1Mg2F"};